module.exports = __webpack_public_path__ + "static/media/盈盈港湾.451d43a6.jpg";